'use strict';

var ServerStyleSheets$1 = require('../../node_modules/@material-ui/styles/esm/ServerStyleSheets/ServerStyleSheets.js');

var ServerStyleSheets = ServerStyleSheets$1;

module.exports = ServerStyleSheets;
